import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Accessor.js";
import a from "../../core/Handles.js";
import i from "../../core/Logger.js";
import { destroyMaybe as n, abortMaybe as s, isSome as l, unwrap as r, isNone as o } from "../../core/maybe.js";
import { createTask as p, whenOrAbort as d, isAborted as u } from "../../core/promiseUtils.js";
import { property as c } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as f } from "../../core/accessorSupport/decorators/subclass.js";
import { project as h, canProjectWithoutEngine as g, isLoaded as y } from "../../geometry/projection.js";
import { mayHaveHeightModelInfo as _, deriveHeightModelInfoFromLayer as k } from "../../geometry/support/heightModelInfoUtils.js";
import { stringFromViewingMode as v } from "../ViewingMode.js";
var R = 10,
    m = i.getLogger("esri.views.support.DefaultsFromMap");
m.level = "info";

var x = /*#__PURE__*/function (_t) {
  _inherits(x, _t);

  var _super = _createSuper(x);

  function x(e) {
    var _this;

    _classCallCheck(this, x);

    _this = _super.call(this, e), _this._handles = new a(), _this.required = {
      tileInfo: !1,
      heightModelInfo: !1,
      extent: !1
    }, _this.defaultSpatialReference = null, _this.userSpatialReference = null, _this.priorityCollection = null, _this.logDebugInformation = !1, _this.suspended = !1, _this._projectExtentTask = {
      task: null,
      input: null,
      output: null,
      spatialReference: null
    };
    return _this;
  }

  _createClass(x, [{
    key: "destroy",
    value: function destroy() {
      this._handles = n(this._handles), this._projectExtentTask.task && (this._debug("Aborting project extent task"), this._projectExtentTask.task = s(this._projectExtentTask.task)), this._set("map", null);
    }
  }, {
    key: "ready",
    get: function get() {
      return !this._spatialReferenceTask.updating && !this._tileInfoTask.updating && !this._extentTask.updating;
    }
  }, {
    key: "heightModelInfoReady",
    get: function get() {
      return !this._heightModelInfoTask.updating;
    }
  }, {
    key: "spatialReference",
    get: function get() {
      return l(this.userSpatialReference) ? this.userSpatialReference : r(this._spatialReferenceTask.spatialReference);
    }
  }, {
    key: "extent",
    get: function get() {
      return r(this._extentTask.extent);
    }
  }, {
    key: "heightModelInfo",
    get: function get() {
      return r(this._heightModelInfoTask.heightModelInfo);
    }
  }, {
    key: "vcsWkid",
    get: function get() {
      return r(this._heightModelInfoTask.vcsWkid);
    }
  }, {
    key: "latestVcsWkid",
    get: function get() {
      return r(this._heightModelInfoTask.latestVcsWkid);
    }
  }, {
    key: "viewingMode",
    get: function get() {
      return o(this.userSpatialReference) || this.userSpatialReference.equals(r(this._spatialReferenceTask.spatialReference)) ? r(this._spatialReferenceTask.viewingMode) : null;
    }
  }, {
    key: "tileInfo",
    get: function get() {
      return r(this._tileInfoTask.tileInfo);
    }
  }, {
    key: "mapCollections",
    get: function get() {
      var e, t, a, i;
      var n = null == (e = this.map) ? void 0 : e.call(this),
          s = [];
      return l(this.priorityCollection) && s.push(this.priorityCollection), s.push({
        parent: null == n ? void 0 : n.basemap,
        layers: null == n || null == (t = n.basemap) ? void 0 : t.baseLayers
      }, {
        layers: null == n ? void 0 : n.layers
      }, {
        parent: null == n ? void 0 : n.ground,
        layers: null == n || null == (a = n.ground) ? void 0 : a.layers
      }, {
        parent: null == n ? void 0 : n.basemap,
        layers: null == n || null == (i = n.basemap) ? void 0 : i.referenceLayers
      }), s;
    }
  }, {
    key: "_allLayers",
    get: function get() {
      var e, t;

      var a = this._collectLayers(this.mapCollections);

      return this._debug("Collected", null != (e = null == (t = a.layers) ? void 0 : t.length) ? e : 0, "layers, updating", a.updating), a;
    }
  }, {
    key: "_spatialReferenceTask",
    get: function get() {
      var e, t;
      if (this.suspended) return null != (t = this._get("_spatialReferenceTask")) ? t : {
        updating: !1
      };
      var _this$_allLayers = this._allLayers,
          a = _this$_allLayers.layers,
          i = _this$_allLayers.updating,
          n = {
        candidates: null
      };

      var _iterator = _createForOfIteratorHelper(a),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _l = _step.value;
          if (this._processSpatialReferenceCandidates(_l, n), n.candidates && 1 === n.candidates.length) break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (1 !== (null == (e = n.candidates) ? void 0 : e.length) && i) return {
        updating: !0
      };

      var s = this._pickSpatialReferenceCandidate(n.candidates);

      return this._debug("Finished spatial reference", l(s) ? "".concat(s.spatialReference.wkid, ":").concat(l(s.viewingMode) ? v(s.viewingMode) : "global/local") : "none available"), {
        spatialReference: l(s) ? s.spatialReference : null,
        viewingMode: l(s) ? s.viewingMode : null,
        updating: !1
      };
    }
  }, {
    key: "_tileInfoTask",
    get: function get() {
      var e, t, a, i, n, s, l, r;
      if (!this.required.tileInfo) return null != (r = this._get("_tileInfoTask")) ? r : {
        updating: !1
      };
      if (!this.spatialReference) return {
        updating: this._spatialReferenceTask.updating
      };

      var _this$_collectLayers = this._collectLayers([{
        parent: null == (e = this.map) || null == (t = e.call(this)) ? void 0 : t.basemap,
        layers: null == (a = this.map) || null == (i = a.call(this)) || null == (n = i.basemap) ? void 0 : n.baseLayers
      }, {
        layers: null == (s = this.map) || null == (l = s.call(this)) ? void 0 : l.layers
      }]),
          o = _this$_collectLayers.layers,
          p = _this$_collectLayers.updating;

      if (o && o.length > 0 && "tileInfo" in o[0]) {
        var _e = o[0].tileInfo;
        return {
          tileInfo: _e && _e.spatialReference.equals(this.spatialReference) ? _e : null,
          updating: !1
        };
      }

      return {
        updating: p
      };
    }
  }, {
    key: "_heightModelInfoTask",
    get: function get() {
      var e, t;
      if (!this.required.heightModelInfo || this.suspended && null != (e = this._get("_heightModelInfoTask")) && e.heightModelInfo) return null != (t = this._get("_heightModelInfoTask")) ? t : {
        updating: !1
      };
      var _this$_allLayers2 = this._allLayers,
          a = _this$_allLayers2.layers,
          i = _this$_allLayers2.updating;

      var _iterator2 = _createForOfIteratorHelper(a),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _o = _step2.value;
          var n, s;

          if (this._debug("Considering", null != (n = null != (s = _o.title) ? s : _o.id) ? n : _o.declaredClass, "for height model info"), _(_o)) {
            var _e2 = k(_o);

            var l, r;
            if (_e2) return this._debug("Derived height model info", _e2), {
              heightModelInfo: _e2,
              vcsWkid: null == (l = _o.spatialReference) ? void 0 : l.vcsWkid,
              latestVcsWkid: null == (r = _o.spatialReference) ? void 0 : r.latestVcsWkid,
              updating: !1
            };
          }

          this._debug("Layer does not support height models");
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return this._debug("No height model info found,", "updating", i), {
        updating: i
      };
    }
  }, {
    key: "_extentCandidatesTask",
    get: function get() {
      var _this2 = this;

      var e;
      if (this.suspended || !this.required.extent) return null != (e = this._get("_extentCandidatesTask")) ? e : {
        updating: !1
      };
      if (!this.spatialReference) return {
        updating: this._spatialReferenceTask.updating
      };
      var t = this._allLayers,
          a = t.updating,
          i = [];

      var _iterator3 = _createForOfIteratorHelper(t.layers),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _n = _step3.value;

          var _e3 = "fullExtents" in _n && _n.fullExtents || (l(_n.fullExtent) ? [_n.fullExtent] : []),
              _t2 = _e3.find(function (e) {
            return e.spatialReference.equals(_this2.spatialReference);
          });

          if (_t2) return {
            candidates: [{
              extent: _t2,
              layer: _n
            }],
            updating: !1
          };

          if (this._getSupportedSpatialReferences(_n).length > 0) {
            var _iterator4 = _createForOfIteratorHelper(_e3),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _a = _step4.value;
                i.push({
                  extent: _a,
                  layer: _n
                });
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return {
        candidates: i,
        updating: a
      };
    }
  }, {
    key: "_extentTask",
    get: function get() {
      var _this3 = this;

      var _this$_extentCandidat = this._extentCandidatesTask,
          e = _this$_extentCandidat.candidates,
          t = _this$_extentCandidat.updating;
      if (t) return {
        updating: t
      };
      if (o(e) || 0 === e.length) return {
        updating: !1
      };
      if (!this.spatialReference) return {
        updating: this._spatialReferenceTask.updating
      };

      var _this$_pickExtentCand = this._pickExtentCandidate(e),
          a = _this$_pickExtentCand.candidate,
          i = _this$_pickExtentCand.requiresGeometryService,
          n = this.spatialReference;

      if (a.extent.equals(this._projectExtentTask.input) && n.equals(this._projectExtentTask.spatialReference)) return {
        extent: this._projectExtentTask.output,
        updating: l(this._projectExtentTask.task) && !this._projectExtentTask.task.finished
      };

      if (l(this._projectExtentTask.task) && (this._debug("Aborting project extent task"), this._projectExtentTask.task = s(this._projectExtentTask.task)), !i) {
        this._projectExtentTask = {
          input: null,
          output: null,
          task: null,
          spatialReference: null
        };

        try {
          return {
            extent: h(a.extent, n),
            updating: !1
          };
        } catch (_unused) {
          return {
            updating: !1
          };
        }
      }

      return this._debug("Starting project extent task for", a.extent), this._projectExtentTask = {
        input: a.extent.clone(),
        output: null,
        spatialReference: n.clone(),
        task: p( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
            var _t3, _i;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return d(import("../../portal/support/geometryServiceUtils.js"), e);

                  case 3:
                    _t3 = _context.sent;
                    _context.next = 6;
                    return _t3.projectGeometry(a.extent, n, a.layer.portalItem, e);

                  case 6:
                    _i = _context.sent;
                    _this3._debug("Project extent task finished", _i), _this3._projectExtentTask = _objectSpread(_objectSpread({}, _this3._projectExtentTask), {}, {
                      task: null,
                      output: _i
                    });
                    _context.next = 15;
                    break;

                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](0);

                    if (!u(e)) {
                      _context.next = 14;
                      break;
                    }

                    return _context.abrupt("return");

                  case 14:
                    _this3._projectExtentTask = _objectSpread(_objectSpread({}, _this3._projectExtentTask), {}, {
                      task: null
                    });

                  case 15:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 10]]);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }())
      }, {
        updating: !0
      };
    }
  }, {
    key: "_processSpatialReferenceCandidates",
    value: function _processSpatialReferenceCandidates(e, t) {
      var a;

      var i = this._getSupportedSpatialReferences(e);

      if (0 !== i.length) if (this._debug("Spatial reference candidates from", null != (a = e.title) ? a : e.id, ":", i.map(function (e) {
        return "".concat(e.spatialReference.wkid, ":").concat(l(e.viewingMode) ? v(e.viewingMode) : "global/local");
      }).join(", ")), t.candidates) {
        var _e4 = [],
            _a2 = function _a2(e, t) {
          return o(e.viewingMode) ? t.viewingMode : (o(t.viewingMode) || e.viewingMode === t.viewingMode) && e.viewingMode;
        };

        var _iterator5 = _createForOfIteratorHelper(t.candidates),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _n2 = _step5.value;

            var _iterator6 = _createForOfIteratorHelper(i),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _t4 = _step6.value;
                if (!_n2.spatialReference.equals(_t4.spatialReference)) continue;

                var _i2 = _a2(_n2, _t4);

                if (!1 !== _i2) {
                  _e4.push({
                    spatialReference: _n2.spatialReference,
                    viewingMode: _i2
                  });

                  break;
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        _e4.length > 0 && (t.candidates = _e4);
      } else t.candidates = i;
    }
  }, {
    key: "_pickSpatialReferenceCandidate",
    value: function _pickSpatialReferenceCandidate(e) {
      var t = this.defaultSpatialReference;
      return !e || e.length < 1 ? l(t) ? {
        spatialReference: t,
        viewingMode: null
      } : null : l(t) && e.length > 1 && e.some(function (_ref2) {
        var e = _ref2.spatialReference;
        return e.equals(t);
      }) ? {
        spatialReference: t,
        viewingMode: null
      } : e[0];
    }
  }, {
    key: "_getSupportedSpatialReferences",
    value: function _getSupportedSpatialReferences(e) {
      var t = "supportedSpatialReferences" in e && e.supportedSpatialReferences || (e.spatialReference ? [e.spatialReference] : []);
      if (0 === t.length) return [];
      var a = [];

      var _iterator7 = _createForOfIteratorHelper(t),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _i3 = _step7.value;

          var _t5 = this.getSpatialReferenceSupport({
            spatialReference: _i3,
            layer: e
          });

          if (l(_t5)) {
            var _e5 = l(_t5.constraints) ? _t5.constraints : [{
              spatialReference: _i3
            }];

            var _iterator8 = _createForOfIteratorHelper(_e5),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _step8$value = _step8.value,
                    _t6 = _step8$value.spatialReference,
                    _i4 = _step8$value.viewingMode;
                (o(this.userSpatialReference) || _t6.equals(this.userSpatialReference)) && a.push({
                  spatialReference: _t6,
                  viewingMode: _i4
                });
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return a;
    }
  }, {
    key: "_pickExtentCandidate",
    value: function _pickExtentCandidate(e) {
      var t = this.spatialReference,
          a = e.find(function (_ref3) {
        var e = _ref3.extent;
        return g(e.spatialReference, t) || y();
      });
      return l(a) ? {
        candidate: a,
        requiresGeometryService: !1
      } : {
        candidate: e[0],
        requiresGeometryService: !0
      };
    }
  }, {
    key: "_collectLayers",
    value: function _collectLayers(e) {
      var t;
      if ("loaded" !== this._loadMaybe(null == (t = this.map) ? void 0 : t.call(this))) return {
        layers: [],
        updating: !0
      };
      var a = {
        layers: [],
        preloading: -1,
        updating: !1
      };

      var _iterator9 = _createForOfIteratorHelper(e),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _i5 = _step9.value;
          if (this._collectCollection(_i5, a), a.preloading === R) break;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return {
        layers: a.layers,
        updating: a.updating
      };
    }
  }, {
    key: "_collectCollection",
    value: function _collectCollection(e, t) {
      if (e.layers) {
        switch (this._loadMaybe(e.parent)) {
          case "loading":
            return t.updating = !0, void ++t.preloading;

          case "failed":
            return;
        }

        var _iterator10 = _createForOfIteratorHelper(e.layers),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _n3 = _step10.value;

            switch (this._loadMaybe(_n3)) {
              case "failed":
                continue;

              case "loading":
                t.updating = !0, ++t.preloading;
                break;

              case "loaded":
                var a, i;
                if (!t.updating) this._debug("Considering layer", null != (a = null != (i = _n3.title) ? i : _n3.id) ? a : _n3.declaredClass), t.layers.push(_n3);
                "layers" in _n3 && this._collectCollection({
                  layers: _n3.layers
                }, t);
            }

            if (t.preloading === R) break;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    }
  }, {
    key: "_loadMaybe",
    value: function _loadMaybe(e) {
      return e && "loadStatus" in e ? "not-loaded" === e.loadStatus ? (this._debug("Triggering load", null != (t = null != (a = e.title) ? a : e.id) ? t : e.declaredClass), e.load(), "loading") : e.loadStatus : "loaded";
      var t, a;
    }
  }, {
    key: "_debug",
    value: function _debug() {
      this.logDebugInformation && m.info.apply(m, arguments);
    }
  }]);

  return x;
}(t);

e([c()], x.prototype, "required", void 0), e([c({
  constructOnly: !0
})], x.prototype, "map", void 0), e([c({
  constructOnly: !0
})], x.prototype, "getSpatialReferenceSupport", void 0), e([c()], x.prototype, "defaultSpatialReference", void 0), e([c()], x.prototype, "userSpatialReference", void 0), e([c()], x.prototype, "priorityCollection", void 0), e([c()], x.prototype, "logDebugInformation", void 0), e([c()], x.prototype, "suspended", void 0), e([c({
  readOnly: !0
})], x.prototype, "ready", null), e([c({
  readOnly: !0
})], x.prototype, "heightModelInfoReady", null), e([c({
  readOnly: !0
})], x.prototype, "spatialReference", null), e([c({
  readOnly: !0
})], x.prototype, "extent", null), e([c({
  readOnly: !0
})], x.prototype, "heightModelInfo", null), e([c({
  readOnly: !0
})], x.prototype, "vcsWkid", null), e([c({
  readOnly: !0
})], x.prototype, "latestVcsWkid", null), e([c({
  readOnly: !0
})], x.prototype, "viewingMode", null), e([c({
  readOnly: !0
})], x.prototype, "tileInfo", null), e([c({
  readOnly: !0
})], x.prototype, "mapCollections", null), e([c({
  readOnly: !0
})], x.prototype, "_allLayers", null), e([c({
  readOnly: !0
})], x.prototype, "_spatialReferenceTask", null), e([c({
  readOnly: !0
})], x.prototype, "_tileInfoTask", null), e([c({
  readOnly: !0
})], x.prototype, "_heightModelInfoTask", null), e([c({
  readOnly: !0
})], x.prototype, "_extentCandidatesTask", null), e([c()], x.prototype, "_extentTask", null), e([c()], x.prototype, "_projectExtentTask", void 0), x = e([f("esri.views.support.DefaultsFromMap")], x);
var T = x;
export { T as default };